import { loadRemoteModule } from '@angular-architects/module-federation';
import { Component, computed, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { HeaderService } from '../../../shared/services/header.service';
import config from '../../../../assets/config.json';
import { requestforEmulationPayload } from '../../../shared/models/model';
import { EmulationService } from '../../../shared/services/emulation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-grant-user',
  standalone: true,
  imports: [],
  templateUrl: './grant-user.component.html',
  styleUrl: './grant-user.component.scss',
})
export class GrantUserComponent implements OnInit {
  token: string = '';
  isAuthorized: Boolean = false;
  @ViewChild('GrantUserComponent', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  @ViewChild('UnauthorizedComponent', { read: ViewContainerRef, static: true })
  unautorizecontainer!: ViewContainerRef;
  constructor(
    private _authservice: AuthorizationService,
    private _headerService: HeaderService,
    private _emulationService: EmulationService,
    private _router: Router,
  ) {
    this._authservice.getAccessToken().then((token) => {
      this.token = token;
    });
  }

  async ngOnInit() {
    await this.checkAuthorization();
    if (this.isAuthorized) {
      const { GrantUserComponent } = await loadRemoteModule({
        type: 'module',
        remoteEntry: config.accessDelegationRemoteURL,
        exposedModule: './GrantUserComponent',
      });
      const componentFactory: any = this.container.createComponent(GrantUserComponent);
      componentFactory.instance.token = this.token;
      componentFactory.instance.roles = this._authservice.getFormattedGroups();
      this.container.insert(componentFactory.hostView);
    } else {
      this._router.navigateByUrl('unauthorized');
    }
  }
  async checkAuthorization() {
    this.isAuthorized = this._headerService.hasADAccess();
    if (!this.isAuthorized) {
      const payload: requestforEmulationPayload = {
        requestingSystem: 'FinPro',
        isEmulating: this.emulatedUser() ? true : false,
        emulatingUserId: this.emulatedUser()?.userId || '',
      };
      try {
        const data = await this._headerService.getNavigationHeader(payload)?.toPromise();
        if (data) {
          this.isAuthorized = this._headerService.hasAccessDelegation(data);
        }
      } catch (error) {
        console.error('Error fetching navigation header:', error);
      }
    }
  }
}
